
function emailOctopus() {
    jQuery('.emailoctopus-form-row').each(function () {
        var label = jQuery(this).find('.emailoctopus-label');
        var text = label.text().replace('*', '').trim();
        var input = jQuery(this).find('input');
        input.attr('placeholder', text);
    });
}

module.exports = emailOctopus;